import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import swal from 'sweetalert'
import Axios from "axios";
import Config from "../../config.js"
import { Link } from "react-router-dom/cjs/react-router-dom.min";
const useStyles = makeStyles(styles);

export default function Profile(props) {
  const { user } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    links: user && user.links,
    linkUrl: "",
    linkKey: "",
  });
  var Call = () => {
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      links: state.links,
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        swal("با موفقیت انجام شد.");
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }

  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }

  const handleUrlClick = (url) => {
    window.open(url, "_blank") //to open new page
  };
  const addToLinkList = () => {
    if (state.linkUrl == "")
      return swal("هیچ یک از مقادیر نمی تواند خالی باشد.");
    if(!state.linkUrl.startsWith("http://")&&!state.linkUrl.startsWith("https://")){
      return swal("آدرس اینترنتی بایست با http:// یا https:// شروع شود.");
    }
    if(validURL(state.linkUrl)){

      if(state.linkUrl.indexOf("linkedin.com/")!=-1)
    state.linkKey="لینکدین"
    else if(state.linkUrl.indexOf("instagram.com/")!=-1)
    state.linkKey="اینستاگرام"
    else if(state.linkUrl.indexOf("facebook.com/")!=-1)
    state.linkKey="فیس بوک"
    else if(state.linkUrl.indexOf("skype.com/")!=-1)
    state.linkKey="اسکایپ"
    else if(state.linkUrl.indexOf("aparat.com/")!=-1)
    state.linkKey="آپارات"
    else if(state.linkUrl.indexOf("stackoverflow.com/")!=-1)
    state.linkKey="استک اورفلو"
    else if(state.linkUrl.indexOf("youtube.com")!=-1)
    state.linkKey="یوتیوب"
    else if(state.linkUrl.indexOf("jobinja.ir/")!=-1)
    state.linkKey="جابینجا"
    else if(state.linkUrl.indexOf("jobvision.ir/")!=-1)
    state.linkKey="جاب ویژن"
    else if(state.linkUrl.indexOf("irantalent.com/")!=-1)
    state.linkKey="ایران تلنت"
    else if(state.linkUrl.indexOf("sharifcamp.ir/")!=-1)
    state.linkKey="شریف آی سی تی"
    else state.linkKey="سایر"


      state.links.push({
        Link: state.linkUrl,
        Key: state.linkKey
      })
    }else{
         return swal("آدرس اینترنتی نادرست است");
    }
    setState({ ...state, "links": state.links })
    setState({ ...state, "linkKey": null, "linkUrl": "" })
  };
  const removeFromList = (source, tttt, valueToRemove) => {
    var e = source.filter(item => item !== valueToRemove)
    setState({ ...state, [tttt]: e })
  };

  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined" >

            <GridContainer>
              <GridItem xs={12} sm={12} md={5}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    لینک‌ها
      </Typography>
                  
                  <div className={classes.formInput+" "+classes.en}>
                    <TextField type='url'  id="standard-basic" name="linkUrl" value={state.linkUrl} onChange={handleTextBoxChange} label="لینک وب" helperText="eg: https://example.gov.ir" />
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <Button variant="outlined" color="secondary" disableElevation onClick={addToLinkList}>
                      افزودن به لیست
</Button>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={7}>
                <div className={classes.div}>
                  {user && state.links.length > 0 ? (
                    <div className={classes.formInput + " " + classes.chipMargin}>
                      {user && state.links.map((link) => {
                        var inputProps = {
                        };
                        return (
                          <Chip onClick={()=>handleUrlClick(link.Link)} variant='outlined' label={link.Link+" ("+link.Key+")"} onDelete={() => { removeFromList(state.links, 'links', link) }} color="primary" {...inputProps} />
                        );
                      })}
                    </div>
                  ) : <p><br />موردی جهت نمایش وجود ندارد.</p>}
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en + " " + classes.save}>
                  <Button variant="contained" color="primary" disableElevation onClick={Call}>
                    ذخیره سازی
                </Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>

      </GridContainer>
    </form>
  );
}